var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleNext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle_next_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circle_next_svg__cls-1{fill:#dae9fa}.circle_next_svg__cls-2{fill:#1f61d9}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle_next_svg__cls-1",
    cx: 33,
    cy: 33,
    r: 25.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle_next_svg__cls-2",
    d: "M33 60a27 27 0 1127-27 27.07 27.07 0 01-27 27zm0-51.92A24.92 24.92 0 1057.92 33 24.95 24.95 0 0033 8.08z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle_next.133c85ea60a9f996eabdc3b77d95ff93.svg";